<template>
    <transition name="fade" @after-enter="afterEnter">
        <div class="popup" style="background-image: url('static/img/main/point1/popup/bg.jpg');" ref="popup">
            <div class="popup-bg delay3"></div>
            <div class="popup-inner ">
                <a href="#" class="close" @click.prevent="closePopup"></a>
                <div class="left delay6">
                    <div class="quotes quotes-right">
                    <span class="text">
                       Мне нравится местный климат, природа и культура. Обожаю испанские маленькие прибрежные города
                    </span>
                    </div>
                    <div class="info">
                    <span class="point">
                        <span class="text">
                            Аликанте, Испания
                        </span>
                    </span>
                        <h3 class="head">
                            Аликанте — город <br>светлого сияния
                        </h3>
                        <span class="desc">
                            Натуральная косметика Weleda сотрудничает с кооперативом, который управляет 6000 га органических миндальных рощ под Аликанте. Сборщики миндаля здесь отказались от интенсивного полива деревьев, так как искусственное орошение приводит к эрозии и засолению почвы.
                            У этого решения, как у большинства экологических инициатив, есть цена: с одного гектара такой земли фермер получает всего 500 кг миндаля, что в десять раз меньше, чем, например, в Калифорнии, где практикуют «агрессивный» полив.
                            Разницу в фермерском заработке компенсирует Weleda, для которой производство высококачественного органического миндального масла давно перестало быть всего лишь бизнесом.
                    </span>
                    </div>
                </div>
                <div class="right delay9">
                    <div class="popup-products">
                        <div class="info">
                            <h4 class="head">
                                Миндаль
                            </h4>
                            <span class="desc">
                                Миндальное масло считается одним из самых ценных, применяемых в косметологии. Оно успокаивает раздраженную кожу, окутывает ее невесомым защитным слоем и увлажняет кожу.                        </span>
                            <a href="https://www.weleda.ru/%D0%BA%D1%80%D0%B0%D1%81%D0%BE%D1%82%D0%B0-%D0%BE%D1%82-%D0%BF%D1%80%D0%B8%D1%80%D0%BE%D0%B4%D1%8B/c%D1%8B%D1%80%D1%8C%D0%B5%D0%B2%D1%8B%D0%B5-%D0%BF%D1%80%D0%BE%D0%B5%D0%BA%D1%82%D1%8B/%D0%BC%D0%B8%D0%BD%D0%B4%D0%B0%D0%BB%D1%8C?utm_source=afisha&utm_medium=card&utm_content=almond&utm_campaign=weleda_afisha_sp_summer_2018" target="_blank" class="btn" @click="gaEvents('places','click','know more ')">
                                Подробнее
                            </a>
                        </div>
                        <div class="img popup-products-img1">
                            <img src="static/img/main/point1/popup/product.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import {TweenMax} from 'gsap';
    import  popupMix from '@/components/pages/popups/popup_mix.vue';

    export default {
        name: 'popup1',
        mixins: [popupMix],
    }
</script>



// WEBPACK FOOTER //
// popup1.vue?3197ba22